import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Specialites from './components/Specialites';
import APropos from './components/APropos';
import Galerie from './components/Galerie';
import Menu from './components/Menu';
import Horaires from './components/Horaires';
import InfosPratiques from './components/InfosPratiques';
import Avis from './components/Avis';
import Contact from './components/Contact';
import Footer from './components/Footer';
import StickyNav from './components/StickyNav';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative bg-white">
      <StickyNav scrolled={scrolled} />
      <Hero />
      <Specialites />
      <APropos />
      <Galerie />
      <Menu />
      <Horaires />
      <InfosPratiques />
      <Avis />
      <Contact />
      <Footer />
    </div>
  );
}